import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';

import { Store } from '@ngrx/store';
import { ILogoutRequest } from '../../../features/auth/models/logout.model';
import * as logout from '../../../features/auth/actions/logout.actions';
import { SearchLegalEntitiesComponent } from '../search-legal-entities/search-legal-entities.component';
import * as legalEntitiesActions from '../../../features/todos/actions';
import * as toDoSelectors from '../../../features/todos/selectors';
import * as toDoActions from '../../../features/todos/actions';
import * as paymentRunActions from '../../../features/payment-runs/actions';
import * as staticDataActions from '../../../static-data/actions';
import * as authSelector from '../../../features/auth/selectors';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { getSavedBusinessId } from '../../../features/legal-entities/selectors/legal-entities-list.selectors';
import { IBusinessUserRolesRequest, IBusinessUserRolesResponse } from '../../../features/auth/models/business-user-roles.model';
import { RouteURL, SessionStorageIds } from '../../../shared/enums';
import * as authActions from '../../../features/auth/actions';
import { ILegalEntitiesBusinessesResponse } from '../../../features/todos/models/businesses.model';
import { APP_CONFIG } from '../../../config/app-config.module';
import { AppConfig } from '../../../core/config-models/app-config.model';
import { SharedService } from '../../shared.service';
import { PubSubService } from '../../pubsub.service';
import { PermissionService } from '../../../core/services/permission.service';
import { AdviserLandingService } from '../../../core/services/adviser-landing.service';

@Component({
  selector: 'app-new-toolbar',
  templateUrl: './new-toolbar.component.html',
  styleUrls: ['./new-toolbar.component.css']//,
})
export class NewToolbarComponent implements OnInit, OnDestroy {
  items: any[];
  showSearchProductSolutions: boolean = false;
  subscription: Subscription = new Subscription();
  roles$: Observable<IBusinessUserRolesResponse>;
  role: string;
  avatarItems: any[];
  userMobile: string | null;
  subdomain: string;
  chosenLegalEntity: string;
  isRegulationVerified: boolean;
  isPaymentMethodAdded: boolean;
  isProductChosen: boolean;

  hasSettingsPermission: boolean = false;
  isLegalEntitiesLoaded: boolean = false;
  legalEntitiesDisplay: boolean;
  legalEntityHistoryDisplay: boolean;
  mobileMenuOpen: boolean = false;
  @ViewChild('historyComponent') historyComponent: any;

  userName: string;
  userID: string;
  signUpDate: number;

  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private pubsubService: PubSubService,
    private permissionService: PermissionService,
    private adviserLandingService: AdviserLandingService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.dispatchToBusinessUserRoles();
    this.store.dispatch(staticDataActions.loadLegalEntityTypes());
    this.store.dispatch(legalEntitiesActions.loadToolbarNotifications());
    this.store.dispatch(legalEntitiesActions.loadBusinesses({ param: '', noLoader: false }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setLegalEntityName = (leName: string) => {
    this.chosenLegalEntity = leName || '';
  }

  ngOnInit(): void {
    this.pubsubService.subscription('SET_LEGAL_ENTITY_HEADER', this.setLegalEntityName).subscribe();
    this.subdomain = this.sharedService.getSubDomain();
    let le = sessionStorage.getItem(SessionStorageIds.LEGAL_ENTITY);
    this.userMobile = sessionStorage.getItem(SessionStorageIds.USER_MOBILE);
    const updateHeaderLegalEntity = (selectedLE: ILegalEntitiesBusinessesResponse | undefined) => {
      const currentUrl = this.router.url;
      const isTodoOrFromTodo = currentUrl.indexOf('/todo') !== -1 ||
        currentUrl.indexOf('/admin-dashboard') !== -1 ||
        this.sharedService.isFromTODO;
      const isSearch = currentUrl.indexOf('/search') !== -1;
      if (isTodoOrFromTodo || isSearch) {
        this.setLegalEntityName('');
        return;
      }
      if (currentUrl.indexOf('/employee-details') !== -1 || currentUrl.indexOf('/product-detail') !== -1) {
        return;
      }
      const sessionLe = sessionStorage.getItem(SessionStorageIds.LEGAL_ENTITY);
      const legalEntity = selectedLE !== undefined ? selectedLE : (sessionLe ? (JSON.parse(sessionLe) as ILegalEntitiesBusinessesResponse) : null);
      if (legalEntity) {
        this.setLegalEntityName(legalEntity.legalEntityName);
        this.pubsubService.publish('RELOAD_SIDENAV_MENU', legalEntity.legalEntityName);
      } else {
        this.setLegalEntityName('');
      }
    };

    this.subscription.add(
      this.store.select(toDoSelectors.getSelectedLegalEntity).subscribe(selectedLE => updateHeaderLegalEntity(selectedLE))
    );
    this.subscription.add(
      this.router.events.pipe(filter(evt => evt instanceof NavigationEnd)).subscribe(() => {
        updateHeaderLegalEntity(undefined);
        this.updateToolbarItems();
      })
    );

    this.updateToolbarItems();

    // Close legal entity popup when a new entity is selected (e.g. from dashboard when already on dashboard)
    this.subscription.add(
      this.store
        .select(getSavedBusinessId)
        .pipe(
          filter((id): id is string => !!id),
          distinctUntilChanged()
        )
        .subscribe(() => {
          if (this.legalEntitiesDisplay) {
            this.legalEntitiesDisplay = false;
          }
        })
    );

    this.roles$ = this.store.select(authSelector.selectBusinessUserRole);

    this.subscription.add(
      this.permissionService.hasAnyPermission(['settings.view', 'settings.edit'], false).subscribe(
        hasPermission => (this.hasSettingsPermission = hasPermission)
      )
    );

    this.avatarItems = [
      {
        label: 'Logout',
        command: onclick => {
          this.logout();
        }
      }
    ];

    this.subscription.add(
      this.roles$.subscribe(role => {
        if (role) {
          sessionStorage.setItem(SessionStorageIds.PERMISSIONS, JSON.stringify(role));
          if (role.permissions?.length) {
            sessionStorage.setItem(SessionStorageIds.AUTH_PERMISSIONS, JSON.stringify(role.permissions));
            this.permissionService.refreshFromSession();
          }
          this.role = role.role;
          this.userName = role.userName;
          this.userID = role.userId;
          this.signUpDate = role.signupDate;

          const legEntitiesAsString = sessionStorage.getItem(SessionStorageIds.LEGAL_ENTITIES);
          if (legEntitiesAsString != null) {
            const legEntities = JSON.parse(legEntitiesAsString);
            this.isLegalEntitiesLoaded = legEntities && legEntities.length > 0;
            this.updateToolbarItems();
          } else {
            this.subscription.add(
              this.store.select(toDoSelectors.selectLegalEntitiesBusinesses).subscribe(businesses => {
                if (businesses && businesses.length > 0) {
                  sessionStorage.setItem(SessionStorageIds.LEGAL_ENTITIES, JSON.stringify(businesses));
                  this.isLegalEntitiesLoaded = true;
                  this.updateToolbarItems();
                }
              })
            );
          }

        }
      })
    );

    this.subscription.add(
      this.store.select(toDoSelectors.selectRegulationVerified).subscribe(response => {
        if (response !== undefined) {
          this.isRegulationVerified = response.regulationVerified;
          this.isPaymentMethodAdded = response.paymentMethodAdded;
          this.isProductChosen = response.productsChosen;
          this.sharedService.defaultCurrencyCode = response.currencyCode;
          this.sharedService.defaultCurrencySymbol =
            response.currencySymbol ||
            (response.currencyCode ? getCurrencySymbol(response.currencyCode, 'narrow') : this.sharedService.defaultCurrencySymbol);
          this.sharedService.navigateToPage = response.navigateToPage;
          this.sharedService.isLegalEntityTypeBusiness = response.legalEntityTypeId
            ? this.sharedService.legalEntityTypeBusinessId == response.legalEntityTypeId.toLowerCase()
            : false;

          if (this.sharedService.isFromLegalEntities) {
            this.sharedService.isFromLegalEntities = false;
          }
        }
      })
    );
  }

  searchLegalEntities() {
    this.legalEntitiesDisplay = true;

  }

  searchProductSolutions() {
    this.showSearchProductSolutions = true;
    this.router.navigateByUrl('product-solutions');
  }

  navToDashboard() {
    this.router.navigateByUrl(RouteURL.ADMIN_DASHBOARD);
  }

  toGlobalSearch() {
    this.router.navigateByUrl('search');
  }

  toSettings() {
    this.router.navigateByUrl('settings');
  }

  logout() {
    const token = sessionStorage.getItem('token');
    const req: ILogoutRequest = {
      token,
      uniqueDeviceId: '00000000-0000-0000-0000-000000000000'
    };
    this.store.dispatch(logout.loadLogoutRequest({ request: req }));
  }

  showLegalEntityHistory() {
    this.legalEntityHistoryDisplay = true;
  }

  showOtherUserToolbar() {
    // Advisers, employers and William Strike users work within a legal entity, so they don't get the global Admin Dashboard link
    const dashboardItem = AdviserLandingService.landsOnLegalEntity()
      ? []
      : [
          {
            label: 'Dashboard',
            command: onclick => {
              this.navToDashboard();
            }
          }
        ];

    this.items = [
      ...dashboardItem,
      {
        label: 'Legal Entities',
        command: onclick => {
          this.searchLegalEntities();
        }
      },
      {
        label: 'Recent History',
        command: onclick => {
          this.showLegalEntityHistory();
        }
      }
    ];
  }

  private shouldShowGlobalTopMenu(): boolean {
    const url = this.router.url.split('?')[0];
    return (
      url === '/admin-dashboard' ||
      url === '/todo' ||
      url === '/search' ||
      url.includes('/employee-details') ||
      url.includes('/product-detail') ||
      this.sharedService.isFromTODO
    );
  }

  private updateToolbarItems(): void {
    if (this.shouldShowGlobalTopMenu() || this.isLegalEntitiesLoaded) {
      this.showOtherUserToolbar();
    }
  }

  dispatchToBusinessUserRoles() {
    const businessId =
      sessionStorage.getItem('businessId') === 'null' || sessionStorage.getItem('businessId') === null
        ? null
        : sessionStorage.getItem('businessId');

        const userRolesReq: IBusinessUserRolesRequest = {
          businessId: businessId,
          token: sessionStorage.getItem('token'),
          uniqueDeviceId: '00000000-0000-0000-0000-000000000000'
        };
        this.store.dispatch(authActions.loadBusinessUserRoles({ request: userRolesReq }));
        if (businessId) {
          this.store.dispatch(toDoActions.loadRegulationVerified({ businessId: businessId }));
        }
  }

  onLeftMenuItemClick(e){
    // Item 0 is the logo; the rest mirror this.items. Resolve by label, not position, because
    // the Dashboard item is left out for advisers / employers and shifts the indexes.
    if (e.itemIndex === 0) {
      this.navToHome();
      return;
    }
    switch (this.items?.[e.itemIndex - 1]?.label) {
      case 'Dashboard':
        this.navToDashboard();
        break;
      case 'Legal Entities':
        this.searchLegalEntities();
        break;
      case 'Recent History':
        this.showLegalEntityHistory();
        break;
    }
  }

  /** Logo: advisers / employers / William Strike users have no Admin Dashboard access, so they go to their first legal entity's landing page. */
  navToHome() {
    if (AdviserLandingService.landsOnLegalEntity()) {
      this.adviserLandingService.navigateToFirstLegalEntity();
    } else {
      this.navToDashboard();
    }
  }

  onRightMenuItemClick(e){
    if(e.itemData.text == 'Logout'){
      this.logout();
    }
  }

  hideSearchLegalEntitiesPopup(){
    this.legalEntitiesDisplay = false;
  }

  hideLegalEntityHistoryPopup() {
    this.legalEntityHistoryDisplay = false;
  }

  onHistoryPopupShown() {
    // Reload history when popup is shown
    if (this.historyComponent) {
      this.historyComponent.loadHistory();
    }
  }
}
